import api from './api';

export const getCountries = async () => {
  const { data } = await api.get('/countries');
  return data;
};

export const createCountry = async (name, tariff) => {
  const { data } = await api.post('/countries', { name, tariff });
  return data;
};

export const updateCountry = async (id, params) => {
  const { data } = await api.put(`/countries/${id}`, params);
  return data;
};

export const deleteCountry = async (id) => {
  const { data } = await api.delete(`/countries/${id}`);
  return data;
};
